import {
  ABOUT_MAX_LENGTH,
  DEFAULT_MAX_LENGTH,
  FIRST_NAME_MAX_LENGTH,
  LAST_NAME_MAX_LENGTH,
} from './validation';

export const maxLengthByInputName = new Map<string, number>([
  ['firstname', FIRST_NAME_MAX_LENGTH],
  ['lastname', LAST_NAME_MAX_LENGTH],
  ['credentials_certifications', DEFAULT_MAX_LENGTH],
  ['education_medicalSchool', DEFAULT_MAX_LENGTH],
  ['education_residency', DEFAULT_MAX_LENGTH],
  ['education_undergraduate', DEFAULT_MAX_LENGTH],
  ['genderDescribe', DEFAULT_MAX_LENGTH],
  ['about', ABOUT_MAX_LENGTH],
]);
